<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Gestion des mandats assignés en attente de rappel"
          class="bg-light shadow"
          title-tag="h6"
        >
          <div class="card-body" v-if="loaded" v-html="waiting"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageWait",
  components: {},
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats assignés en attente de rappel",
          active: true,
        },
      ],
      waiting: {},
      busy: false,
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.busy = true;
      gestion.assigned().then((response) => {
        this.waiting = response.data;
        this.busy = false;
        this.loaded = true;
      });
    },
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>